import * as React from 'react'

const SvgComponent = (props) => (
  <svg width={23} height={27} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M.83 10.955c.128-.13.608-.688 1.055-1.147 2.622-2.887 9.46-7.612 13.04-9.054C15.468.522 16.843.03 17.577 0a4.35 4.35 0 0 1 2.014.49 4.216 4.216 0 0 1 1.789 2.035c.226.591.576 2.362.576 2.393.351 1.938.544 5.086.544 8.564 0 3.314-.193 6.334-.48 8.3-.033.032-.384 2.232-.767 2.986C20.549 26.145 19.175 27 17.704 27h-.127c-.958-.034-2.972-.889-2.972-.92-3.387-1.445-10.068-5.938-12.753-8.924 0 0-.756-.767-1.085-1.246C.254 15.22 0 14.368 0 13.516c0-.952.287-1.838.83-2.56Z"
      fill="currentColor"
    />
  </svg>
)

export default SvgComponent
